import './CharacterIcon.css';
import claudiImg from './claudi.png';
import eddyImg from './eddy.png';
import rockImg from './rock.png';
import tuchiImg from './tuchi.png';
import ufoImg from './ufo.png';
import vallImg from './vall.png';

const CHARACTER_ICONS = {
  vall: vallImg,
  ufo: ufoImg,
  tuchi: tuchiImg,
  claudi: claudiImg,
  eddy: eddyImg,
  rock: rockImg,
} as const;

export type CharacterIconId = keyof typeof CHARACTER_ICONS;

export const CHARACTER_ORDER = [
  'vall',
  'ufo',
  'tuchi',
  'claudi',
  'eddy',
  'rock',
] as const satisfies readonly CharacterIconId[];

export type CharacterIconProps = {
  name: CharacterIconId;
  className?: string;
};

/** All character arts stay mounted; only the selected one is visible. */
export function CharacterIcon({ name, className }: CharacterIconProps) {
  return (
    <>
      {CHARACTER_ORDER.map((id) => (
        <img
          key={id}
          className={[
            'character-icon',
            `character-icon--${id}`,
            id === name ? null : 'character-icon--hidden',
            className,
          ]
            .filter(Boolean)
            .join(' ')}
          src={CHARACTER_ICONS[id]}
          alt=""
          draggable={false}
          aria-hidden={id !== name}
        />
      ))}
    </>
  );
}
